import API from "api/API";
import useFetchData from "hooks/useFetchData";

export default function useUDCompareFilters( name1, name2 ) {
   return useFetchData({
      APIMethod: API.getUDCompareFilters,
      condition: !!name1 && !!name2,
      cache_name: `${name1}-${name2}-ud-compare-filters`,
      params: [ name1, name2 ]
   })
}
